// ----------------------------------------------------------------------
// <copyright file="Izenda.AdvancedImportToolbar.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * AdvancedImportToolbar component
 */
!(function() {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var IconMenu = require('share/components/controls/Izenda.IconMenu');
  var ActionButton = require('share/components/controls/Izenda.ActionButton');
  var Button = require('share/components/controls/Izenda.Button');
  var Alert = require('share/components/controls/Izenda.Alert');


  var AdvancedImportToolbar = React.createClass({
    render: function() {
      var localization = this.props.localization;
      var alertMessage = this.props.alertMessage;

      return (
        <div className="izenda-Wrapper-header">
          <IconMenu />
          <Alert type={alertMessage.type} className="pull-left">
            {alertMessage.message}
          </Alert>
          <div className="izenda-ActionBarRight">
            <ActionButton>
              <Button
                label={localization.getText('COMMON_LABEL_VALIDATE')}
                onClick={this.props.onValidate}
                className="btn-success"
              />
            </ActionButton>
            <Button
              className="btn-setting-default"
              label={localization.getText('COMMON_LABEL_CLOSE')}
              onClick={this.props.onClose}
            />
          </div>
        </div>
      );
    }
  });

  module.exports = connect()(AdvancedImportToolbar);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Import/DataModel/AdvancedImport/Izenda.AdvancedImportToolbar.jsx